<template>
  <div v-if="showClauses" :id="'clauses--' + index" data-test="proposal-basket-clauses-content">
    <span v-for="(clause, number) in clauses" :key="'clause-' + number">
      <h4 class="proposal-clauses__title" v-html="clause.title" />
      <p
        v-if="clause.description"
        :data-test="'clause-' + number + '-description'"
        v-html="clause.description"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { BasketProposalClause } from '@/store/modules/interfaces/ProposalBasketStoreState';

export default defineComponent({
  name: 'ProposalClauses',
  props: {
    index: {
      type: Number,
      default() {
        return 0;
      }
    },
    clauses: {
      type: Array as PropType<BasketProposalClause[]>,
      default() {
        return [];
      }
    }
  },
  computed: {
    showClauses(): boolean {
      return this.clauses.length > 0;
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'src/styles/typography/_fonts.scss';

.proposal-clauses {
  &__title {
    margin-bottom: rem-calc(5);
    font-family: $base-font-bold;
    color: black;
  }
}
</style>
